'use strict';

const Footer = {
    el: null,
    tools: null,
    stopTarget: null,
    toggle: null,
    moveTop: null,
    init: function () {
        Footer.el = document.querySelector('.footer');
        Footer.tools = document.querySelector('.footer__tools');

        if (!Footer.el || !Footer.tools) {
            return;
        }

        const MOBILE_BREAKPOINT = 841;

        const resolveStopTarget = () => {
            const isDesktop = window.matchMedia(`(min-width: ${MOBILE_BREAKPOINT}px)`).matches;

            if (!isDesktop) {
                Footer.stopTarget = null;
                return;
            }

            Footer.stopTarget = document.querySelector('.footer__stop-target');

            if (!Footer.stopTarget || !Footer.stopTarget.getClientRects().length) {
                Footer.stopTarget = Footer.el.querySelector('.footer__agence');
            }
        };

        resolveStopTarget();

        Footer.moveTop = Footer.tools.querySelector(".footer__tools__moveTop");

        const TOOLS_BOTTOM_OFFSET = 38;
        let pendingFrame = null;

        const updateToolsPosition = () => {
            pendingFrame = null;

            if (!Footer.stopTarget) {
                Footer.tools.style.setProperty('--footer-tools-offset', '0px');
                return;
            }

            const currentScroll = window.scrollY || 0;
            const stopTargetTop = Footer.stopTarget.getBoundingClientRect().top + currentScroll;
            const toolsHeight = Footer.tools.offsetHeight;
            const fixedBottom = currentScroll + window.innerHeight - TOOLS_BOTTOM_OFFSET;
            const overlap = Math.max(0, fixedBottom - stopTargetTop);
            const maxOffset = Math.max(0, window.innerHeight - TOOLS_BOTTOM_OFFSET - toolsHeight);
            const offset = Math.min(overlap, maxOffset);

            Footer.tools.style.setProperty('--footer-tools-offset', `${offset * -1}px`);
        };

        const requestToolsPositionUpdate = () => {
            if (pendingFrame) {
                return;
            }

            pendingFrame = window.requestAnimationFrame(updateToolsPosition);
        };

        const TOP_THRESHOLD = 100;

        const setMoveTopVisibility = isVisible => {
            Footer.moveTop.classList.toggle("is-visible", isVisible);
            Footer.moveTop.setAttribute("aria-hidden", isVisible ? "false" : "true");
            Footer.moveTop.tabIndex = isVisible ? 0 : -1;
        };

        const onScroll = () => {
            const currentScroll = window.scrollY || 0;

            if (Footer.moveTop) {
                setMoveTopVisibility(currentScroll > TOP_THRESHOLD);
            }

            requestToolsPositionUpdate();
        };

        if (Footer.moveTop) {
            const scrollToTop = () => {
                const scrollRoot = document.scrollingElement || document.documentElement;
                const start = scrollRoot.scrollTop || window.scrollY || 0;
                const duration = 300;
                const startTime = window.performance.now();
                const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

                if (reduceMotion || start <= 0) {
                    scrollRoot.scrollTop = 0;
                    return;
                }

                const easeInOutCubic = progress => (
                    progress < 0.5
                        ? 4 * progress * progress * progress
                        : 1 - Math.pow(-2 * progress + 2, 3) / 2
                );

                const step = currentTime => {
                    const elapsed = currentTime - startTime;
                    const progress = Math.min(elapsed / duration, 1);

                    scrollRoot.scrollTop = start * (1 - easeInOutCubic(progress));

                    if (progress < 1) {
                        window.requestAnimationFrame(step);
                    }
                };

                window.requestAnimationFrame(step);
            };

            Footer.moveTop.addEventListener("click", () => {
                scrollToTop();
            });

            setMoveTopVisibility(false);
        }

        document.addEventListener("scroll", onScroll);
        window.addEventListener("resize", () => {
            resolveStopTarget();
            requestToolsPositionUpdate();
        });
        onScroll();
    }
};

export default Footer;
